import PinLight2Icon from '../../../../../../../assets/svgs/PinLight2'
import style from './style.module.css'

const PositionItem = () => {
  return (
    <div className={style.companyModal_position_item}>
      <span className={style.companyModal_position_title}>
        Data scientist, Product
      </span>

      <div className={style.companyModal_position_location}>
        <PinLight2Icon />
        <span>Menlo Park, CA</span>
      </div>
    </div>
  )
}

export default PositionItem
